export const countries = {
  AE: {
    code: 'AE',
    name: _TL_('United Arab Emirates'),
  },
  AF: {
    code: 'AF',
    name: _TL_('Afghanistan'),
  },
  AD: {
    code: 'AD',
    name: _TL_('Andorra'),
  },
  AI: {
    code: 'AI',
    name: _TL_('Anguilla'),
  },
  AG: {
    code: 'AG',
    name: _TL_('Antigua & Barbuda'),
  },
  AL: {
    code: 'AL',
    name: _TL_('Albania'),
  },
  AM: {
    code: 'AM',
    name: _TL_('Armenia'),
  },
  AO: {
    code: 'AO',
    name: _TL_('Angola'),
  },
  AQ: {
    code: 'AQ',
    name: _TL_('Antarctica'),
  },
  AR: {
    code: 'AR',
    name: _TL_('Argentina'),
  },
  AT: {
    code: 'AT',
    name: _TL_('Austria'),
  },
  AU: {
    code: 'AU',
    name: _TL_('Australia'),
  },
  AW: {
    code: 'AW',
    name: _TL_('Aruba'),
  },
  BB: {
    code: 'BB',
    name: _TL_('Barbados'),
  },
  BD: {
    code: 'BD',
    name: _TL_('Bangladesh'),
  },
  BF: {
    code: 'BF',
    name: _TL_('Burkina Faso'),
  },
  BG: {
    code: 'BG',
    name: _TL_('Bulgaria'),
  },
  BH: {
    code: 'BH',
    name: _TL_('Bahrain'),
  },
  BI: {
    code: 'BI',
    name: _TL_('Burundi'),
  },
  BJ: {
    code: 'BJ',
    name: _TL_('Benin'),
  },
  BM: {
    code: 'BM',
    name: _TL_('Bermuda'),
  },
  BN: {
    code: 'BN',
    name: _TL_('Brunei'),
  },
  BO: {
    code: 'BO',
    name: _TL_('Bolivia'),
  },
  BR: {
    code: 'BR',
    name: _TL_('Brazil'),
  },
  BS: {
    code: 'BS',
    name: _TL_('Bahamas'),
  },
  BT: {
    code: 'BT',
    name: _TL_('Bhutan'),
  },
  BV: {
    code: 'BV',
    name: _TL_('Bouvet Island'),
  },
  BY: {
    code: 'BY',
    name: _TL_('Belarus'),
  },
  CA: {
    code: 'CA',
    name: _TL_('Canada'),
  },
  CC: {
    code: 'CC',
    name: _TL_('Cocos (Keeling) Islands'),
  },
  CD: {
    code: 'CD',
    name: _TL_('Congo – Kinshasa'),
  },
  CF: {
    code: 'CF',
    name: _TL_('Central African Republic'),
  },
  CG: {
    code: 'CG',
    name: _TL_('Congo – Brazzaville'),
  },
  CH: {
    code: 'CH',
    name: _TL_('Switzerland'),
  },
  CI: {
    code: 'CI',
    name: _TL_('Côte d’Ivoire'),
  },
  CK: {
    code: 'CK',
    name: _TL_('Cook Islands'),
  },
  CL: {
    code: 'CL',
    name: _TL_('Chile'),
  },
  CM: {
    code: 'CM',
    name: _TL_('Cameroon'),
  },
  CN: {
    code: 'CN',
    name: _TL_('China'),
  },
  CO: {
    code: 'CO',
    name: _TL_('Colombia'),
  },
  CR: {
    code: 'CR',
    name: _TL_('Costa Rica'),
  },
  CU: {
    code: 'CU',
    name: _TL_('Cuba'),
  },
  CV: {
    code: 'CV',
    name: _TL_('Cape Verde'),
  },
  CW: {
    code: 'CW',
    name: _TL_('Curaçao'),
  },
  CX: {
    code: 'CX',
    name: _TL_('Christmas Island'),
  },
  CY: {
    code: 'CY',
    name: _TL_('Cyprus'),
  },
  CZ: {
    code: 'CZ',
    name: _TL_('Czechia'),
  },
  DE: {
    code: 'DE',
    name: _TL_('Germany'),
  },
  DJ: {
    code: 'DJ',
    name: _TL_('Djibouti'),
  },
  DK: {
    code: 'DK',
    name: _TL_('Denmark'),
  },
  DM: {
    code: 'DM',
    name: _TL_('Dominica'),
  },
  DO: {
    code: 'DO',
    name: _TL_('Dominican Republic'),
  },
  DZ: {
    code: 'DZ',
    name: _TL_('Algeria'),
  },
  EC: {
    code: 'EC',
    name: _TL_('Ecuador'),
  },
  EE: {
    code: 'EE',
    name: _TL_('Estonia'),
  },
  EG: {
    code: 'EG',
    name: _TL_('Egypt'),
  },
  EH: {
    code: 'EH',
    name: _TL_('Western Sahara'),
  },
  ER: {
    code: 'ER',
    name: _TL_('Eritrea'),
  },
  ES: {
    code: 'ES',
    name: _TL_('Spain'),
  },
  ET: {
    code: 'ET',
    name: _TL_('Ethiopia'),
  },
  FI: {
    code: 'FI',
    name: _TL_('Finland'),
  },
  FJ: {
    code: 'FJ',
    name: _TL_('Fiji'),
  },
  FM: {
    code: 'FM',
    name: _TL_('Federated States of Micronesia'),
  },
  FR: {
    code: 'FR',
    name: _TL_('France'),
  },
  GA: {
    code: 'GA',
    name: _TL_('Gabon'),
  },
  GB: {
    code: 'GB',
    name: _TL_('United Kingdom'),
  },
  GD: {
    code: 'GD',
    name: _TL_('Grenada'),
  },
  GE: {
    code: 'GE',
    name: _TL_('Georgia'),
  },
  GG: {
    code: 'GG',
    name: _TL_('Guernsey'),
  },
  GH: {
    code: 'GH',
    name: _TL_('Ghana'),
  },
  GI: {
    code: 'GI',
    name: _TL_('Gibraltar'),
  },
  GR: {
    code: 'GR',
    name: _TL_('Greece'),
  },
  GT: {
    code: 'GT',
    name: _TL_('Guatemala'),
  },
  GW: {
    code: 'GW',
    name: _TL_('Guinea-Bissau'),
  },
  GY: {
    code: 'GY',
    name: _TL_('Guyana'),
  },
  HK: {
    code: 'HK',
    name: _TL_('Hong Kong'),
  },
  HN: {
    code: 'HN',
    name: _TL_('Honduras'),
  },
  HR: {
    code: 'HR',
    name: _TL_('Croatia'),
  },
  HT: {
    code: 'HT',
    name: _TL_('Haiti'),
  },
  HU: {
    code: 'HU',
    name: _TL_('Hungary'),
  },
  ID: {
    code: 'ID',
    name: _TL_('Indonesia'),
  },
  IE: {
    code: 'IE',
    name: _TL_('Ireland'),
  },
  IL: {
    code: 'IL',
    name: _TL_('Israel'),
  },
  IN: {
    code: 'IN',
    name: _TL_('India'),
  },
  IQ: {
    code: 'IQ',
    name: _TL_('Iraq'),
  },
  IR: {
    code: 'IR',
    name: _TL_('Iran'),
  },
  IS: {
    code: 'IS',
    name: _TL_('Iceland'),
  },
  IT: {
    code: 'IT',
    name: _TL_('Italy'),
  },
  JE: {
    code: 'JE',
    name: _TL_('Jersey'),
  },
  JM: {
    code: 'JM',
    name: _TL_('Jamaica'),
  },
  JO: {
    code: 'JO',
    name: _TL_('Jordan'),
  },
  JP: {
    code: 'JP',
    name: _TL_('Japan'),
  },
  KE: {
    code: 'KE',
    name: _TL_('Kenya'),
  },
  KG: {
    code: 'KG',
    name: _TL_('Kyrgyzstan'),
  },
  KH: {
    code: 'KH',
    name: _TL_('Cambodia'),
  },
  KI: {
    code: 'KI',
    name: _TL_('Kiribati'),
  },
  KM: {
    code: 'KM',
    name: _TL_('Comoros'),
  },
  KN: {
    code: 'KN',
    name: _TL_('St. Kitts & Nevis'),
  },
  KR: {
    code: 'KR',
    name: _TL_('South Korea'),
  },
  KW: {
    code: 'KW',
    name: _TL_('Kuwait'),
  },
  KY: {
    code: 'KY',
    name: _TL_('Cayman Islands'),
  },
  KZ: {
    code: 'KZ',
    name: _TL_('Kazakhstan'),
  },
  LA: {
    code: 'LA',
    name: _TL_('Laos'),
  },
  LB: {
    code: 'LB',
    name: _TL_('Lebanon'),
  },
  LC: {
    code: 'LC',
    name: _TL_('St. Lucia'),
  },
  LI: {
    code: 'LI',
    name: _TL_('Liechtenstein'),
  },
  LK: {
    code: 'LK',
    name: _TL_('Sri Lanka'),
  },
  LR: {
    code: 'LR',
    name: _TL_('Liberia'),
  },
  LS: {
    code: 'LS',
    name: _TL_('Lesotho'),
  },
  LT: {
    code: 'LT',
    name: _TL_('Lithuania'),
  },
  LU: {
    code: 'LU',
    name: _TL_('Luxembourg'),
  },
  LV: {
    code: 'LV',
    name: _TL_('Latvia'),
  },
  LY: {
    code: 'LY',
    name: _TL_('Libya'),
  },
  MA: {
    code: 'MA',
    name: _TL_('Morocco'),
  },
  MC: {
    code: 'MC',
    name: _TL_('Monaco'),
  },
  MD: {
    code: 'MD',
    name: _TL_('Moldova'),
  },
  ME: {
    code: 'ME',
    name: _TL_('Montenegro'),
  },
  MG: {
    code: 'MG',
    name: _TL_('Madagascar'),
  },
  MK: {
    code: 'MK',
    name: _TL_('North Macedonia'),
  },
  ML: {
    code: 'ML',
    name: _TL_('Mali'),
  },
  MM: {
    code: 'MM',
    name: _TL_('Myanmar'),
  },
  MN: {
    code: 'MN',
    name: _TL_('Mongolia'),
  },
  MO: {
    code: 'MO',
    name: _TL_('Macao'),
  },
  MR: {
    code: 'MR',
    name: _TL_('Mauritania'),
  },
  MS: {
    code: 'MS',
    name: _TL_('Montserrat'),
  },
  MT: {
    code: 'MT',
    name: _TL_('Malta'),
  },
  MU: {
    code: 'MU',
    name: _TL_('Mauritius'),
  },
  MV: {
    code: 'MV',
    name: _TL_('Maldives'),
  },
  MW: {
    code: 'MW',
    name: _TL_('Malawi'),
  },
  MX: {
    code: 'MX',
    name: _TL_('Mexico'),
  },
  MY: {
    code: 'MY',
    name: _TL_('Malaysia'),
  },
  MZ: {
    code: 'MZ',
    name: _TL_('Mozambique'),
  },
  NA: {
    code: 'NA',
    name: _TL_('Namibia'),
  },
  NE: {
    code: 'NE',
    name: _TL_('Niger'),
  },
  NF: {
    code: 'NF',
    name: _TL_('Norfolk Island'),
  },
  NG: {
    code: 'NG',
    name: _TL_('Nigeria'),
  },
  NI: {
    code: 'NI',
    name: _TL_('Nicaragua'),
  },
  NL: {
    code: 'NL',
    name: _TL_('Netherlands'),
  },
  NO: {
    code: 'NO',
    name: _TL_('Norway'),
  },
  NP: {
    code: 'NP',
    name: _TL_('Nepal'),
  },
  NR: {
    code: 'NR',
    name: _TL_('Nauru'),
  },
  NU: {
    code: 'NU',
    name: _TL_('Niue'),
  },
  NZ: {
    code: 'NZ',
    name: _TL_('New Zealand'),
  },
  OM: {
    code: 'OM',
    name: _TL_('Oman'),
  },
  PA: {
    code: 'PA',
    name: _TL_('Panama'),
  },
  PE: {
    code: 'PE',
    name: _TL_('Peru'),
  },
  PG: {
    code: 'PG',
    name: _TL_('Papua New Guinea'),
  },
  PH: {
    code: 'PH',
    name: _TL_('Philippines'),
  },
  PK: {
    code: 'PK',
    name: _TL_('Pakistan'),
  },
  PL: {
    code: 'PL',
    name: _TL_('Poland'),
  },
  PT: {
    code: 'PT',
    name: _TL_('Portugal'),
  },
  PS: {
    code: 'PS',
    name: _TL_('Palestinian Territory'),
  },
  QA: {
    code: 'QA',
    name: _TL_('Qatar'),
  },
  RO: {
    code: 'RO',
    name: _TL_('Romania'),
  },
  RS: {
    code: 'RS',
    name: _TL_('Serbia'),
  },
  RU: {
    code: 'RU',
    name: _TL_('Russia'),
  },
  RW: {
    code: 'RW',
    name: _TL_('Rwanda'),
  },
  SA: {
    code: 'SA',
    name: _TL_('Saudi Arabia'),
  },
  SB: {
    code: 'SB',
    name: _TL_('Solomon Islands'),
  },
  SC: {
    code: 'SC',
    name: _TL_('Seychelles'),
  },
  SD: {
    code: 'SD',
    name: _TL_('Sudan'),
  },
  SE: {
    code: 'SE',
    name: _TL_('Sweden'),
  },
  SG: {
    code: 'SG',
    name: _TL_('Singapore'),
  },
  SH: {
    code: 'SH',
    name: _TL_('Saint Helena'),
  },
  SI: {
    code: 'SI',
    name: _TL_('Slovenia'),
  },
  SK: {
    code: 'SK',
    name: _TL_('Slovakia'),
  },
  SM: {
    code: 'SM',
    name: _TL_('San Marino'),
  },
  SN: {
    code: 'SN',
    name: _TL_('Senegal'),
  },
  SO: {
    code: 'SO',
    name: _TL_('Somalia'),
  },
  SR: {
    code: 'SR',
    name: _TL_('Suriname'),
  },
  ST: {
    code: 'ST',
    name: _TL_('São Tomé & Príncipe'),
  },
  SV: {
    code: 'SV',
    name: _TL_('El Salvador'),
  },
  SZ: {
    code: 'SZ',
    name: _TL_('Eswatini'),
  },
  TC: {
    code: 'TC',
    name: _TL_('Turks & Caicos Islands'),
  },
  TD: {
    code: 'TD',
    name: _TL_('Chad'),
  },
  TF: {
    code: 'TF',
    name: _TL_('French Southern Territories'),
  },
  TG: {
    code: 'TG',
    name: _TL_('Togo'),
  },
  TH: {
    code: 'TH',
    name: _TL_('Thailand'),
  },
  TJ: {
    code: 'TJ',
    name: _TL_('Tajikistan'),
  },
  TK: {
    code: 'TK',
    name: _TL_('Tokelau'),
  },
  TL: {
    code: 'TL',
    name: _TL_('East Timor'),
  },
  TM: {
    code: 'TM',
    name: _TL_('Turkmenistan'),
  },
  TN: {
    code: 'TN',
    name: _TL_('Tunisia'),
  },
  TR: {
    code: 'TR',
    name: _TL_('Türkiye'),
  },
  TT: {
    code: 'TT',
    name: _TL_('Trinidad & Tobago'),
  },
  TV: {
    code: 'TV',
    name: _TL_('Tuvalu'),
  },
  TW: {
    code: 'TW',
    name: _TL_('Taiwan'),
  },
  TZ: {
    code: 'TZ',
    name: _TL_('Tanzania'),
  },
  UA: {
    code: 'UA',
    name: _TL_('Ukraine'),
  },
  UG: {
    code: 'UG',
    name: _TL_('Uganda'),
  },
  UM: {
    code: 'UM',
    name: _TL_('US Minor Outlying Islands'),
  },
  US: {
    code: 'US',
    name: _TL_('United States'),
  },
  UY: {
    code: 'UY',
    name: _TL_('Uruguay'),
  },
  UZ: {
    code: 'UZ',
    name: _TL_('Uzbekistan'),
  },
  VA: {
    code: 'VA',
    name: _TL_('Vatican City'),
  },
  VC: {
    code: 'VC',
    name: _TL_('St. Vincent & Grenadines'),
  },
  VE: {
    code: 'VE',
    name: _TL_('Venezuela'),
  },
  VG: {
    code: 'VG',
    name: _TL_('British Virgin Islands'),
  },
  VN: {
    code: 'VN',
    name: _TL_('Vietnam'),
  },
  VU: {
    code: 'VU',
    name: _TL_('Vanuatu'),
  },
  WS: {
    code: 'WS',
    name: _TL_('Samoa'),
  },
  YE: {
    code: 'YE',
    name: _TL_('Yemen'),
  },
  ZM: {
    code: 'ZM',
    name: _TL_('Zambia'),
  },
  ZW: {
    code: 'ZW',
    name: _TL_('Zimbabwe'),
  },
  IO: {
    code: 'IO',
    name: _TL_('British Indian Ocean Territory'),
  },
  XK: {
    code: 'XK',
    name: _TL_('Kosovo'),
  },
  BQ: {
    code: 'BQ',
    name: _TL_('Saba'),
  },
  GS: {
    code: 'GS',
    name: _TL_('South Georgia & South Sandwich Islands'),
  },
  WF: {
    code: 'WF',
    name: _TL_('Wallis and Futuna'),
  },
};
